import { apiFetch, readJsonSafe } from "./apiClient";

export const MASTER_JOB_LABELS = {
  latestJobs: "latest-jobs",
  latestResults: "latest-results",
  admitCards: "admit-cards",
  admission: "admission",
  answerKeys: "answer-keys",
  syllabus: "doc",
};

export const normalizeMasterJobLabel = (label = "") => {
  let normalized = String(label || "").trim();

  try {
    normalized = decodeURIComponent(normalized.replace(/\+/g, " "));
  } catch {
    normalized = normalized.replace(/\+/g, " ");
  }

  return normalized
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

const requestJson = async (path, options = {}) => {
  const response = await apiFetch(path, options);
  const data = await readJsonSafe(response);

  if (!response.ok) {
    const error = new Error(data?.message || `Request failed with status ${response.status}.`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const masterJobsReadApi = {
  getLatest(label) {
    return requestJson(`/api/master-jobs/latest/${normalizeMasterJobLabel(label)}`);
  },

  getBySlug(slugWithId) {
    return requestJson(`/api/master-jobs/job/${encodeURIComponent(slugWithId)}`);
  },

  getById(id) {
    return requestJson(`/api/master-jobs/jobbyid/${encodeURIComponent(id)}`);
  },
};

export const masterJobsActionApi = {
  scrape({ url, includeLegacyPostWise = false }) {
    return requestJson(
      `/api/master-jobs/scrape${buildQueryString({
        url,
        includeLegacyPostWise,
      })}`,
      {
        auth: true,
        skipUnauthorizedHandler: true,
      }
    );
  },

  aiDirect(url) {
    return requestJson(
      `/api/master-jobs/ai-direct${buildQueryString({ url })}`,
      {
        auth: true,
        skipUnauthorizedHandler: true,
      }
    );
  },

  scrapeAndSave({ url, label, force = false, includeLegacyPostWise = false }) {
    return requestJson(
      `/api/master-jobs/scrape-and-save${buildQueryString({
        url,
        label: normalizeMasterJobLabel(label),
        force,
        includeLegacyPostWise,
      })}`,
      {
        method: "POST",
        auth: true,
        skipUnauthorizedHandler: true,
      }
    );
  },

  autoScrapeHomepage({ force = false, maxLinks = 0, maxPerCategory = 1 }) {
    return requestJson(
      `/api/master-jobs/auto-scrape-homepage${buildQueryString({
        force,
        maxLinks,
        maxPerCategory,
      })}`,
      {
        method: "POST",
        auth: true,
        skipUnauthorizedHandler: true,
      }
    );
  },

  runHourlyScheduler() {
    return requestJson("/api/master-jobs/run-hourly-scheduler", {
      method: "POST",
      auth: true,
      skipUnauthorizedHandler: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  adminSave({ label, payload }) {
    return requestJson(
      `/api/master-jobs/admin/save${buildQueryString({
        label: normalizeMasterJobLabel(label),
      })}`,
      {
        method: "POST",
        auth: true,
        skipUnauthorizedHandler: true,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
  },

  adminUpdate({ id, label, payload }) {
    return requestJson(
      `/api/master-jobs/admin/${encodeURIComponent(id)}${buildQueryString({
        label: normalizeMasterJobLabel(label),
      })}`,
      {
        method: "PUT",
        auth: true,
        skipUnauthorizedHandler: true,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
  },
};
